 
 <ngx-one-column-layout>
      
      <router-outlet></router-outlet>
    </ngx-one-column-layout>
 
  <!--<div class="auth-block"></div>-->


